import styled from "styled-components";
import media from "constants/media";

export const UspStyled = styled.li`
    display: flex;
    align-items: center;

    color: var(--color-darkNight);
    font-size: 14px;
    line-height: 20px;

    ${media.smUp`
        margin-bottom: 10px;
        font-size: 15px;
        line-height: 25px;
    `}
`;

export const IconContainer = styled.div`
    padding-right: 12px;

    svg {
        width: 15px;
        height: 12px;
    }
`;
